import styled from "styled-components";
import React from "react";
import {useQuery} from "react-query";
import {blueprintCategory} from "../../../../../utils/const/query-key";
import apiService from "../../../../../api/apiService";


const Wrapper = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
`
const BpCategoryContainer = styled.div`
  display: flex;
  padding: 0px;
  flex-wrap: nowrap;
`;

const CardBpCategory = styled.button`
  height: 36px;
  white-space: nowrap;
  padding: 0 10px;
  background: var(--color-workspace-bg-page-area);
  border: 1px solid var(--color-createenv-form-btn-border);
  cursor: pointer;
  list-style: none;
  display: flex;
  border-radius: 3px 0px 0px 3px;
  justify-content: center;
  align-items: center;
   &:hover {
    color: var(--color-brand-pink-primary);
    border-color: var(--color-brand-pink-primary);
    background-color: var(--color-brand-pink-light-selected);
    outline: none;
    }
     ${props => props.selected && `
    color: var(--color-brand-pink-primary);
    border-color: var(--color-brand-pink-primary);
    background-color: var(--color-brand-pink-light-selected);
    outline: none;
  `}
     
`;



export const BlueprintTopBar = ({filter = "All", setFilter, tableInstance}) => {
    const {data: blueprintCategoryData} = useQuery(blueprintCategory, () =>
            apiService.getBlueprintCategoryData(),
        {staleTime: Infinity}
    );
    const validBlueprintCategory = blueprintCategoryData?.filter(bp => bp.isvalid);

    const onClickHandle = (category) => {
        if (category !== filter) {
            setFilter(category);
        }
    }


    return (
        <Wrapper>
            <BpCategoryContainer>
                <CardBpCategory id={"blueprint_all_tab"} selected={filter === "All"} onClick={() => {
                    onClickHandle("All")
                }}>
                    All
                </CardBpCategory>
                {validBlueprintCategory?.map(bp => {
                    return (
                        <CardBpCategory
                            key={bp.name}
                            selected={bp.name === filter}
                            onClick={() => onClickHandle(bp.name)}
                        >
                            <img style={{ width: 16, height: 16, marginRight: 5}} src={bp.icon} alt={bp.name} />
                            <span>{bp.name}</span>
                        </CardBpCategory>
                    );
                })}
            </BpCategoryContainer>
        </Wrapper>
    );
};
